var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicrophoneBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/M/microphone_solid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 15.75C14.0711 15.75 15.75 14.0711 15.75 12V5.75C15.75 3.67891 14.0711 2 12 2C9.92891 2 8.25 3.67891 8.25 5.75V12C8.25 14.0711 9.92891 15.75 12 15.75ZM18.25 9.5H17.625C17.2797 9.5 17 9.77969 17 10.125V12C17 14.9219 14.4809 17.2664 11.5004 16.9758C8.90273 16.7223 7 14.3871 7 11.7773V10.125C7 9.77969 6.72031 9.5 6.375 9.5H5.75C5.40469 9.5 5.125 9.77969 5.125 10.125V11.6938C5.125 15.1953 7.62383 18.3168 11.0625 18.791V20.125H8.875C8.52969 20.125 8.25 20.4047 8.25 20.75V21.375C8.25 21.7203 8.52969 22 8.875 22H15.125C15.4703 22 15.75 21.7203 15.75 21.375V20.75C15.75 20.4047 15.4703 20.125 15.125 20.125H12.9375V18.8059C16.2855 18.3465 18.875 15.4727 18.875 12V10.125C18.875 9.77969 18.5953 9.5 18.25 9.5Z",
    fill: "#637381"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneBlack);
export default __webpack_public_path__ + "static/media/microphone_black.45c319ce63963a97632e812574e052f1.svg";
export { ForwardRef as ReactComponent };